import api from './index'
import { axios } from '@/utils/request'
const FILE_URL = process.env.VUE_APP_API_FILE_URL

export function loginUser (parameter) {
  return axios({
    url: api.loginUser,
    method: 'post',
    data: parameter
  })
}

export function apiAdviceInfo (parameter) {
  return axios({
    url: api.apiAdviceInfo,
    method: 'post',
    data: parameter
  })
}

export function getBottomDate (parameter) {
  return axios({
    url: api.getBottomDate,
    method: 'post',
    data: parameter
  })
}

export function queryList (parameter) {
  return axios({
    url: api.queryList,
    method: 'post',
    data: parameter
  })
}

export function queryListFilterByToken (parameter) {
  return axios({
    url: api.queryListFilterByToken,
    method: 'post',
    data: parameter
  })
}

export function queryListFilterNotToken (parameter) {
  return axios({
    url: api.queryListFilterNotToken,
    method: 'post',
    data: parameter
  })
}

export function QueryBaseAuthForApp (parameter) {
  return axios({
    url: api.QueryBaseAuthForApp,
    method: 'post',
    data: parameter
  })
}

export function docDetail (parameter) {
  return axios({
    url: api.docDetail,
    method: 'post',
    data: parameter
  })
}

export function LoginCodeAvatar (parameter) {
  return axios({
    url: api.LoginCodeAvatar,
    method: 'post',
    data: parameter
  })
}

export function docQueryList (parameter) {
  return axios({
    url: api.docQueryList,
    method: 'post',
    data: parameter
  })
}

export function LoginCheckImgCode (parameter) {
  return axios({
    url: api.LoginCheckImgCode,
    method: 'post',
    data: parameter
  })
}

export function Register (parameter) {
  return axios({
    url: api.Register,
    method: 'post',
    data: parameter
  })
}

export function SendRetrievePassCore (parameter) {
  return axios({
    url: api.SendRetrievePassCore,
    method: 'post',
    data: parameter
  })
}

export function RetrievePassByPhone (parameter) {
  return axios({
    url: api.RetrievePassByPhone,
    method: 'post',
    data: parameter
  })
}

export function RetrievePassByEmail (parameter) {
  return axios({
    url: api.RetrievePassByEmail,
    method: 'post',
    data: parameter
  })
}

export function RendRetrievePassEmail (parameter) {
  return axios({
    url: api.RendRetrievePassEmail,
    method: 'post',
    data: parameter
  })
}

export function AppqueryList (parameter) {
  return axios({
    url: api.AppqueryList,
    method: 'post',
    data: parameter
  })
}

export function SimpleUserList (parameter) {
  return axios({
    url: api.GetSubSimpleUserList,
    method: 'post',
    data: parameter
  })
}
export function UpdateAppEffective (parameter) {
  return axios({
    url: api.UpdateAppEffective,
    method: 'post',
    data: parameter
  })
}

export function AppResetKey (parameter) {
  return axios({
    url: api.AppResetKey,
    method: 'post',
    data: parameter
  })
}

export function viewApp (parameter) {
  return axios({
    url: api.viewApp,
    method: 'post',
    data: parameter
  })
}

export function BannerQueryList (parameter) {
  return axios({
    url: api.BannerQueryList,
    method: 'post',
    data: parameter
  })
}

export function QueryListForApp (parameter) {
  return axios({
    url: api.QueryListForApp,
    method: 'post',
    data: parameter
  })
}

export function AppAdd (parameter) {
  return axios({
    url: api.AppAdd,
    method: 'post',
    data: parameter
  })
}

export function UpdateApp (parameter) {
  return axios({
    url: api.UpdateApp,
    method: 'post',
    data: parameter
  })
}

export function QueryAppInfoByParam (parameter) {
  return axios({
    url: api.QueryAppInfoByParam,
    method: 'post',
    data: parameter
  })
}

export function SystemList (parameter) {
  return axios({
    url: api.SystemList,
    method: 'post',
    data: parameter
  })
}

export function SsogetChilldList (parameter) {
  return axios({
    url: api.SsogetChilldList,
    method: 'post',
    data: parameter
  })
}

export function SsoGetCityInfo (parameter) {
  return axios({
    url: api.SsoGetCityInfo,
    method: 'post',
    data: parameter
  })
}

export function SsoSetSubject (parameter) {
  return axios({
    url: api.SsoSetSubject,
    method: 'post',
    data: parameter
  })
}

export function SsoGetUserInfo (parameter) {
  return axios({
    url: api.SsoGetUserInfo,
    method: 'post',
    data: parameter
  })
}

export function GetSubjectList (parameter) {
  return axios({
    url: api.GetSubjectList,
    method: 'post',
    data: parameter
  })
}

export function CreateOpenApiCompany (parameter) {
  return axios({
    url: api.CreateOpenApiCompany,
    method: 'post',
    data: parameter
  })
}

export function SsoUserChooseSubject (parameter) {
  return axios({
    url: api.SsoUserChooseSubject,
    method: 'post',
    data: parameter
  })
}

export function SsoGetSubjectAuthentication (parameter) {
  return axios({
    url: api.SsoGetSubjectAuthentication,
    method: 'post',
    data: parameter
  })
}

export function QueryDownload (parameter) {
  return axios({
    url: api.QueryDownload,
    method: 'post',
    data: parameter
  })
}
export function GetPersonalUserSub (parameter) {
  return axios({
    url: api.GetPersonalUserSub,
    method: 'post',
    data: parameter
  })
}

export function SsoGetDeactivateStaff (parameter) {
  return axios({
    url: api.SsoGetDeactivateStaff,
    method: 'post',
    data: parameter
  })
}

export function SsoGetUserEditRoleMenuBySys (parameter) {
  return axios({
    url: api.SsoGetUserEditRoleMenuBySys,
    method: 'post',
    data: parameter
  })
}

export function InterfacequeryList (parameter) {
  return axios({
    url: api.InterfacequeryList,
    method: 'post',
    data: parameter
  })
}

export function AddSysSubAccount (parameter) {
  return axios({
    url: api.AddSysSubAccount,
    method: 'post',
    data: parameter
  })
}

export function SsoLogout (parameter) {
  return axios({
    url: api.SsoLogout,
    method: 'post',
    data: parameter
  })
}

export function UpLoadImg (parameter, config = {}) {
  return axios({
    url: api.UpLoadImg,
    method: 'post',
    data: parameter,
    ...config
  })
}

export async function UploadImgage (parameter, config = {}) {
  let data = new FormData()
  for (let i of Object.keys(parameter)) {
    data.append(i, parameter[i])
  }
  return axios({
    FILE_URL,
    url: api.UploadImg,
    method: 'post',
    timeout: 1000 * 60,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config
  })
}

export function SsogetCityInfoByAreaCode (parameter) {
  return axios({
    url: api.SsogetCityInfoByAreaCode,
    method: 'post',
    data: parameter
  })
}

export function SsogetUserRoleMenu (parameter) {
  if (location.host.includes('wms-open.eccang.com')) {
    parameter.source = 'WMS'
  }
  return axios({
    url: api.SsogetUserRoleMenu,
    method: 'post',
    data: parameter
  })
}

export function docQueryListForApi (parameter) {
  return axios({
    url: api.docQueryListForApi,
    method: 'post',
    data: parameter
  })
}

export function QueryAppAuthSubject (parameter) {
  return axios({
    url: api.QueryAppAuthSubject,
    method: 'post',
    data: parameter
  })
}

export function QueryAppAuthOrUnAuthInfo (parameter) {
  return axios({
    url: api.QueryAppAuthOrUnAuthInfo,
    method: 'post',
    data: parameter
  })
}

export function QueryAuthService (parameter) {
  return axios({
    url: api.QueryAuthService,
    method: 'post',
    data: parameter
  })
}

export function QueryOwnerAppAuthInterface (parameter) {
  return axios({
    url: api.QueryOwnerAppAuthInterface,
    method: 'post',
    data: parameter
  })
}

export function PhoneCodeInterface (parameter) {
  return axios({
    url: api.PhoneCodeInterface,
    method: 'post',
    data: parameter
  })
}

export function LocationToAdress (parameter) {
  return axios({
    url: api.LocationToAdress,
    method: 'post',
    data: parameter
  })
}

export function GetEosBaseInfo (parameter) {
  return axios({
    url: api.GetEosBaseInfo,
    method: 'post',
    data: parameter
  })
}

export function ReservationShow (parameter) {
  return axios({
    url: api.ReservationShow,
    method: 'post',
    data: parameter
  })
}

export function QueryDocumentListForApp (parameter) {
  return axios({
    url: api.QueryDocumentListForApp,
    method: 'post',
    data: parameter
  })
}

export function QueryDetail (parameter) {
  return axios({
    url: api.QueryDetail,
    method: 'post',
    data: parameter
  })
}

export function NoticeThirdSystem (parameter) {
  return axios({
    url: api.NoticeThirdSystem,
    method: 'post',
    data: parameter
  })
}

export async function DownloadImg (parameter) {
  return axios({
    FILE_URL,
    url: api.downloadImg,
    responseType: 'blob',
    method: 'post',
    timeout: 1000 * 60,
    data: parameter
  })
}

export function GetAnnouncementYhEjectDetail (parameter) {
  return axios({
    url: api.GetAnnouncementYhEjectDetail,
    method: 'post',
    data: parameter
  })
}

export function TransformLogin (parameter) {
  return axios({
    url: api.TransformLogin,
    method: 'post',
    data: parameter
  })
}

export function QueryPageBindDocument (parameter) {
  return axios({
    url: api.QueryPageBindDocument,
    method: 'post',
    data: parameter
  })
}

export function AddOrEditUserViewField (parameter) {
  return axios({
    url: api.AddOrEditUserViewField,
    method: 'post',
    data: parameter
  })
}

export function QueryUserViewField (parameter) {
  return axios({
    url: api.QueryUserViewField,
    method: 'post',
    data: parameter
  })
}

export function querySystemParamsPage (parameter) {
  return axios({
    url: api.querySystemParamsPage,
    method: 'post',
    data: parameter
  })
}

export function QuerySdkFileInfo (parameter) {
  return axios({
    url: api.QuerySdkFileInfo,
    method: 'post',
    data: parameter
  })
}

export function SsoGetSubjectAuthentications (parameter) {
  return axios({
    url: api.SsoGetSubjectAuthentications,
    method: 'post',
    data: parameter
  })
}

export function QueryApiNum (parameter) {
  return axios({
    url: api.QueryApiNum,
    method: 'post',
    data: parameter
  })
}

export function QuerySystemExtListForSub (parameter) {
  return axios({
    url: api.QuerySystemExtListForSub,
    method: 'post',
    data: parameter
  })
}
